/* eslint-disable max-len */
// 安全验证弹框配置
export default {
  checkTitle: 'Account security: Please verify your identity',
  changeTitleForPhone: 'Please enter the mobile number you want to change.',
  changeTitleForEmail: 'Please enter the email address you want to change. ',
  bindTitleForPhone: 'Please enter the mobile number you want to link.',
  bindTitleForEmail: 'Please enter the email address you want to link.',
};
